
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import _ from  'lodash';

@Component
export default class ValidationErrors extends Vue {
    @Prop() errors!: ValidationErrors;

    get hasErrors() {
        return !_.isEmpty(this.errors);
    }
}
